// extracted by mini-css-extract-plugin
export default {"cell":"Vm7AyHk6","header":"_Ep2ZJg1"};